export type PhoneCountry = {
    iso: string
    callingCode: string
    nameRu: string
    nameEn: string
    aliases?: string[]
    /** Макс. длина national number. Сверх неё набор игнорируем, не меняем страну. */
    nationalMax?: number
}

export const DEFAULT_PHONE_COUNTRY_ISO = 'RU'

/** ITU E.164 NSN, если у страны нет своего nationalMax. */
export const DEFAULT_NATIONAL_MAX = 15

/** Всегда сверху списка (и среди результатов поиска). */
export const PINNED_PHONE_COUNTRY_ISOS = ['RU', 'KZ', 'BY', 'AM'] as const

export const PHONE_COUNTRIES: PhoneCountry[] = [
    { iso: 'RU', callingCode: '7', nameRu: 'Россия', nameEn: 'Russia', aliases: ['рф', 'rf'], nationalMax: 10 },
    { iso: 'KZ', callingCode: '7', nameRu: 'Казахстан', nameEn: 'Kazakhstan', aliases: ['кз', 'kz'], nationalMax: 10 },
    { iso: 'BY', callingCode: '375', nameRu: 'Беларусь', nameEn: 'Belarus', aliases: ['рб', 'белоруссия', 'rb'], nationalMax: 9 },
    { iso: 'AM', callingCode: '374', nameRu: 'Армения', nameEn: 'Armenia', aliases: ['ам'], nationalMax: 8 },
    { iso: 'UZ', callingCode: '998', nameRu: 'Узбекистан', nameEn: 'Uzbekistan', aliases: ['уз'], nationalMax: 9 },
    { iso: 'KG', callingCode: '996', nameRu: 'Кыргызстан', nameEn: 'Kyrgyzstan', nationalMax: 9 },
    { iso: 'TJ', callingCode: '992', nameRu: 'Таджикистан', nameEn: 'Tajikistan', nationalMax: 9 },
    { iso: 'TM', callingCode: '993', nameRu: 'Туркменистан', nameEn: 'Turkmenistan', nationalMax: 8 },
    { iso: 'AZ', callingCode: '994', nameRu: 'Азербайджан', nameEn: 'Azerbaijan', nationalMax: 9 },
    { iso: 'GE', callingCode: '995', nameRu: 'Грузия', nameEn: 'Georgia', nationalMax: 9 },
    { iso: 'MD', callingCode: '373', nameRu: 'Молдова', nameEn: 'Moldova', nationalMax: 8 },
    { iso: 'UA', callingCode: '380', nameRu: 'Украина', nameEn: 'Ukraine', nationalMax: 9 },
    { iso: 'EE', callingCode: '372', nameRu: 'Эстония', nameEn: 'Estonia' },
    { iso: 'LV', callingCode: '371', nameRu: 'Латвия', nameEn: 'Latvia' },
    { iso: 'LT', callingCode: '370', nameRu: 'Литва', nameEn: 'Lithuania' },
    { iso: 'DE', callingCode: '49', nameRu: 'Германия', nameEn: 'Germany' },
    { iso: 'AT', callingCode: '43', nameRu: 'Австрия', nameEn: 'Austria' },
    { iso: 'CH', callingCode: '41', nameRu: 'Швейцария', nameEn: 'Switzerland' },
    { iso: 'FR', callingCode: '33', nameRu: 'Франция', nameEn: 'France', nationalMax: 9 },
    { iso: 'IT', callingCode: '39', nameRu: 'Италия', nameEn: 'Italy' },
    { iso: 'ES', callingCode: '34', nameRu: 'Испания', nameEn: 'Spain' },
    { iso: 'PT', callingCode: '351', nameRu: 'Португалия', nameEn: 'Portugal' },
    { iso: 'GB', callingCode: '44', nameRu: 'Великобритания', nameEn: 'United Kingdom', aliases: ['uk', 'англия'] },
    { iso: 'IE', callingCode: '353', nameRu: 'Ирландия', nameEn: 'Ireland' },
    { iso: 'NL', callingCode: '31', nameRu: 'Нидерланды', nameEn: 'Netherlands' },
    { iso: 'BE', callingCode: '32', nameRu: 'Бельгия', nameEn: 'Belgium' },
    { iso: 'LU', callingCode: '352', nameRu: 'Люксембург', nameEn: 'Luxembourg' },
    { iso: 'PL', callingCode: '48', nameRu: 'Польша', nameEn: 'Poland' },
    { iso: 'CZ', callingCode: '420', nameRu: 'Чехия', nameEn: 'Czechia' },
    { iso: 'SK', callingCode: '421', nameRu: 'Словакия', nameEn: 'Slovakia' },
    { iso: 'HU', callingCode: '36', nameRu: 'Венгрия', nameEn: 'Hungary' },
    { iso: 'RO', callingCode: '40', nameRu: 'Румыния', nameEn: 'Romania' },
    { iso: 'BG', callingCode: '359', nameRu: 'Болгария', nameEn: 'Bulgaria' },
    { iso: 'GR', callingCode: '30', nameRu: 'Греция', nameEn: 'Greece' },
    { iso: 'CY', callingCode: '357', nameRu: 'Кипр', nameEn: 'Cyprus' },
    { iso: 'TR', callingCode: '90', nameRu: 'Турция', nameEn: 'Turkey' },
    { iso: 'RS', callingCode: '381', nameRu: 'Сербия', nameEn: 'Serbia' },
    { iso: 'HR', callingCode: '385', nameRu: 'Хорватия', nameEn: 'Croatia' },
    { iso: 'SI', callingCode: '386', nameRu: 'Словения', nameEn: 'Slovenia' },
    { iso: 'BA', callingCode: '387', nameRu: 'Босния и Герцеговина', nameEn: 'Bosnia and Herzegovina' },
    { iso: 'ME', callingCode: '382', nameRu: 'Черногория', nameEn: 'Montenegro' },
    { iso: 'MK', callingCode: '389', nameRu: 'Северная Македония', nameEn: 'North Macedonia' },
    { iso: 'AL', callingCode: '355', nameRu: 'Албания', nameEn: 'Albania' },
    { iso: 'FI', callingCode: '358', nameRu: 'Финляндия', nameEn: 'Finland' },
    { iso: 'SE', callingCode: '46', nameRu: 'Швеция', nameEn: 'Sweden' },
    { iso: 'NO', callingCode: '47', nameRu: 'Норвегия', nameEn: 'Norway', nationalMax: 8 },
    { iso: 'DK', callingCode: '45', nameRu: 'Дания', nameEn: 'Denmark', nationalMax: 8 },
    { iso: 'IS', callingCode: '354', nameRu: 'Исландия', nameEn: 'Iceland' },
    { iso: 'US', callingCode: '1', nameRu: 'США', nameEn: 'United States', aliases: ['usa', 'америка'], nationalMax: 10 },
    { iso: 'CA', callingCode: '1', nameRu: 'Канада', nameEn: 'Canada', nationalMax: 10 },
    { iso: 'MX', callingCode: '52', nameRu: 'Мексика', nameEn: 'Mexico' },
    { iso: 'BR', callingCode: '55', nameRu: 'Бразилия', nameEn: 'Brazil' },
    { iso: 'AR', callingCode: '54', nameRu: 'Аргентина', nameEn: 'Argentina' },
    { iso: 'CL', callingCode: '56', nameRu: 'Чили', nameEn: 'Chile' },
    { iso: 'CO', callingCode: '57', nameRu: 'Колумбия', nameEn: 'Colombia' },
    { iso: 'PE', callingCode: '51', nameRu: 'Перу', nameEn: 'Peru' },
    { iso: 'AE', callingCode: '971', nameRu: 'ОАЭ', nameEn: 'United Arab Emirates', aliases: ['эмираты'] },
    { iso: 'SA', callingCode: '966', nameRu: 'Саудовская Аравия', nameEn: 'Saudi Arabia' },
    { iso: 'IL', callingCode: '972', nameRu: 'Израиль', nameEn: 'Israel' },
    { iso: 'QA', callingCode: '974', nameRu: 'Катар', nameEn: 'Qatar' },
    { iso: 'KW', callingCode: '965', nameRu: 'Кувейт', nameEn: 'Kuwait' },
    { iso: 'BH', callingCode: '973', nameRu: 'Бахрейн', nameEn: 'Bahrain' },
    { iso: 'OM', callingCode: '968', nameRu: 'Оман', nameEn: 'Oman' },
    { iso: 'JO', callingCode: '962', nameRu: 'Иордания', nameEn: 'Jordan' },
    { iso: 'LB', callingCode: '961', nameRu: 'Ливан', nameEn: 'Lebanon' },
    { iso: 'EG', callingCode: '20', nameRu: 'Египет', nameEn: 'Egypt' },
    { iso: 'MA', callingCode: '212', nameRu: 'Марокко', nameEn: 'Morocco' },
    { iso: 'ZA', callingCode: '27', nameRu: 'ЮАР', nameEn: 'South Africa' },
    { iso: 'NG', callingCode: '234', nameRu: 'Нигерия', nameEn: 'Nigeria' },
    { iso: 'KE', callingCode: '254', nameRu: 'Кения', nameEn: 'Kenya' },
    { iso: 'CN', callingCode: '86', nameRu: 'Китай', nameEn: 'China' },
    { iso: 'HK', callingCode: '852', nameRu: 'Гонконг', nameEn: 'Hong Kong' },
    { iso: 'TW', callingCode: '886', nameRu: 'Тайвань', nameEn: 'Taiwan' },
    { iso: 'JP', callingCode: '81', nameRu: 'Япония', nameEn: 'Japan' },
    { iso: 'KR', callingCode: '82', nameRu: 'Южная Корея', nameEn: 'South Korea' },
    { iso: 'IN', callingCode: '91', nameRu: 'Индия', nameEn: 'India' },
    { iso: 'ID', callingCode: '62', nameRu: 'Индонезия', nameEn: 'Indonesia' },
    { iso: 'TH', callingCode: '66', nameRu: 'Таиланд', nameEn: 'Thailand' },
    { iso: 'VN', callingCode: '84', nameRu: 'Вьетнам', nameEn: 'Vietnam' },
    { iso: 'MY', callingCode: '60', nameRu: 'Малайзия', nameEn: 'Malaysia' },
    { iso: 'SG', callingCode: '65', nameRu: 'Сингапур', nameEn: 'Singapore' },
    { iso: 'PH', callingCode: '63', nameRu: 'Филиппины', nameEn: 'Philippines' },
    { iso: 'PK', callingCode: '92', nameRu: 'Пакистан', nameEn: 'Pakistan' },
    { iso: 'BD', callingCode: '880', nameRu: 'Бангладеш', nameEn: 'Bangladesh' },
    { iso: 'MN', callingCode: '976', nameRu: 'Монголия', nameEn: 'Mongolia' },
    { iso: 'AU', callingCode: '61', nameRu: 'Австралия', nameEn: 'Australia' },
    { iso: 'NZ', callingCode: '64', nameRu: 'Новая Зеландия', nameEn: 'New Zealand' },
]

const BY_ISO = new Map(PHONE_COUNTRIES.map((country) => [country.iso, country]))

const BY_CALLING_CODE = new Map<string, PhoneCountry[]>()
for (const country of PHONE_COUNTRIES) {
    const list = BY_CALLING_CODE.get(country.callingCode) ?? []
    if (!list.some((item) => item.iso === country.iso)) {
        list.push(country)
        BY_CALLING_CODE.set(country.callingCode, list)
    }
}

export function getPhoneCountry(iso?: string | null): PhoneCountry {
    if (iso) {
        const found = BY_ISO.get(iso.toUpperCase())
        if (found) {
            return found
        }
    }
    return BY_ISO.get(DEFAULT_PHONE_COUNTRY_ISO)!
}

export function normalizePhoneCountryIso(iso?: string | null): string {
    return getPhoneCountry(iso).iso
}

export function nationalDigitLimit(iso?: string | null): number {
    return getPhoneCountry(iso).nationalMax ?? DEFAULT_NATIONAL_MAX
}

function clampNationalDigits(digits: string, iso?: string | null): string {
    return digitsOnly(digits).slice(0, nationalDigitLimit(iso))
}

function withClampedNational(parsed: ParsedPhone): ParsedPhone {
    return {
        ...parsed,
        nationalDigits: clampNationalDigits(parsed.nationalDigits, parsed.iso),
    }
}

export function flagEmoji(iso: string): string {
    return iso
        .toUpperCase()
        .replace(/[^A-Z]/g, '')
        .slice(0, 2)
        .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
}

function digitsOnly(value: string): string {
    return (value || '').replace(/\D/g, '')
}

function matchesQuery(country: PhoneCountry, query: string): boolean {
    if (!query) {
        return true
    }
    if (country.callingCode.startsWith(query)) {
        return true
    }
    if (country.iso.toLowerCase() === query) {
        return true
    }
    if (country.nameRu.toLowerCase().includes(query)) {
        return true
    }
    if (country.nameEn.toLowerCase().includes(query)) {
        return true
    }
    return (country.aliases ?? []).some((alias) => alias.toLowerCase().includes(query) || query.includes(alias.toLowerCase()))
}

export function searchPhoneCountries(query: string): PhoneCountry[] {
    const normalized = (query || '').trim().toLowerCase().replace(/^\+/, '')
    const matches = PHONE_COUNTRIES.filter((country) => matchesQuery(country, normalized))
    const seen = new Set<string>()
    const pinned = PINNED_PHONE_COUNTRY_ISOS
        .map((iso) => matches.find((country) => country.iso === iso))
        .filter((country): country is PhoneCountry => Boolean(country))
    const rest = matches
        .filter((country) => !PINNED_PHONE_COUNTRY_ISOS.includes(country.iso as typeof PINNED_PHONE_COUNTRY_ISOS[number]))
        .sort((left, right) => left.nameRu.localeCompare(right.nameRu, 'ru'))
    const result: PhoneCountry[] = []
    for (const country of [...pinned, ...rest]) {
        if (seen.has(country.iso)) {
            continue
        }
        seen.add(country.iso)
        result.push(country)
    }
    return result
}

export type ParsedPhone = {
    iso: string
    callingCode: string
    nationalDigits: string
}

function pickAmongSharedCallingCode(
    matches: PhoneCountry[],
    nationalDigits: string,
    preferredIso?: string,
): PhoneCountry {
    if (matches.length === 1) {
        return matches[0]
    }
    const isos = new Set(matches.map((country) => country.iso))
    if (isos.has('RU') && isos.has('KZ')) {
        if (/^[67]/.test(nationalDigits)) {
            return BY_ISO.get('KZ')!
        }
        if (/^[3489]/.test(nationalDigits)) {
            return BY_ISO.get('RU')!
        }
    }
    if (preferredIso && isos.has(preferredIso)) {
        return BY_ISO.get(preferredIso)!
    }
    for (const iso of PINNED_PHONE_COUNTRY_ISOS) {
        if (isos.has(iso)) {
            return BY_ISO.get(iso)!
        }
    }
    return matches[0]
}

function detectCountryFromDigits(digits: string, preferredIso?: string): ParsedPhone | null {
    for (let length = 3; length >= 1; length -= 1) {
        if (digits.length <= length) {
            continue
        }
        const callingCode = digits.slice(0, length)
        const matches = BY_CALLING_CODE.get(callingCode)
        if (!matches?.length) {
            continue
        }
        const nationalDigits = digits.slice(length)
        if (nationalDigits.length < 4) {
            continue
        }
        const country = pickAmongSharedCallingCode(matches, nationalDigits, preferredIso)
        return {
            iso: country.iso,
            callingCode: country.callingCode,
            nationalDigits,
        }
    }
    return null
}

export function looksLikeInternationalPhone(raw: string, _currentIso?: string): boolean {
    const trimmed = (raw || '').trim()
    if (!trimmed) {
        return false
    }
    if (trimmed.startsWith('+') || trimmed.startsWith('00')) {
        return true
    }
    const digits = digitsOnly(trimmed)
    // Полный RU/KZ без плюса. Лишняя цифра в национальном поле сюда не входит:
    // 11-я на 9xx иначе становилась +91 / +92.
    if (digits.length === 11 && (digits.startsWith('7') || digits.startsWith('8'))) {
        return true
    }
    return false
}

function isCompleteDetectedNumber(detected: ParsedPhone): boolean {
    const completeAt = getPhoneCountry(detected.iso).nationalMax ?? 10
    return detected.nationalDigits.length >= completeAt
}

/** Вставка: + / 00 / полный номер другой страны. Набор лишней цифры — нет. */
export function parsePastedPhone(raw: string, fallbackIso: string = DEFAULT_PHONE_COUNTRY_ISO): ParsedPhone {
    const trimmed = (raw || '').trim()
    if (trimmed.startsWith('+') || trimmed.startsWith('00') || looksLikeInternationalPhone(trimmed, fallbackIso)) {
        return parsePhoneInput(raw, fallbackIso)
    }
    const detected = detectCountryFromDigits(digitsOnly(trimmed), fallbackIso)
    if (detected && isCompleteDetectedNumber(detected)) {
        return withClampedNational(detected)
    }
    return parsePhoneInput(raw, fallbackIso)
}

export function parsePhoneInput(raw: string, fallbackIso: string = DEFAULT_PHONE_COUNTRY_ISO): ParsedPhone {
    const fallback = getPhoneCountry(fallbackIso)
    const trimmed = (raw || '').trim()
    if (!trimmed) {
        return { iso: fallback.iso, callingCode: fallback.callingCode, nationalDigits: '' }
    }

    let digits = digitsOnly(trimmed)
    if (trimmed.startsWith('00') && digits.startsWith('00')) {
        digits = digits.slice(2)
    }

    if (digits.length === 11 && digits.startsWith('8')) {
        return withClampedNational({ iso: 'RU', callingCode: '7', nationalDigits: digits.slice(1) })
    }

    if (trimmed.startsWith('+') || trimmed.startsWith('00') || looksLikeInternationalPhone(trimmed, fallback.iso)) {
        const detected = detectCountryFromDigits(digits, fallback.iso)
        if (detected) {
            return withClampedNational(detected)
        }
        for (let length = 3; length >= 1; length -= 1) {
            const callingCode = digits.slice(0, length)
            const matches = BY_CALLING_CODE.get(callingCode)
            if (!matches?.length) {
                continue
            }
            const nationalDigits = digits.slice(length)
            const country = pickAmongSharedCallingCode(matches, nationalDigits, fallback.iso)
            return withClampedNational({
                iso: country.iso,
                callingCode: country.callingCode,
                nationalDigits,
            })
        }
    }

    if (
        digits.startsWith(fallback.callingCode) &&
        digits.length > fallback.callingCode.length
    ) {
        return withClampedNational({
            iso: fallback.iso,
            callingCode: fallback.callingCode,
            nationalDigits: digits.slice(fallback.callingCode.length),
        })
    }

    return withClampedNational({
        iso: fallback.iso,
        callingCode: fallback.callingCode,
        nationalDigits: digits,
    })
}

export function composePhoneNumber(iso: string, nationalDigits: string): string {
    const country = getPhoneCountry(iso)
    const national = clampNationalDigits(nationalDigits, iso)
    if (!national) {
        return ''
    }
    return `+${country.callingCode}${national}`
}

/**
 * Национальная маска. Для РФ/КЗ — та же группировка, что в
 * TextFieldMasked PHONE_MASKS `+0 (000) 000-00-00`, без кода страны.
 */
export function nationalPhoneMask(iso: string): string {
    const country = getPhoneCountry(iso)
    if (country.callingCode === '7' || country.nationalMax === 10) {
        return '(000) 000-00-00'
    }
    if (country.nationalMax === 8) {
        return '00 00 00 00'
    }
    if (country.nationalMax === 9) {
        return '000 000 000'
    }
    return '000 000 000 000'
}

export function formatNationalPhone(digits: string, iso: string): string {
    const national = clampNationalDigits(digits, iso)
    if (!national) {
        return ''
    }
    const mask = nationalPhoneMask(iso)
    let digitIndex = 0
    let formatted = ''
    for (const char of mask) {
        if (digitIndex >= national.length) {
            break
        }
        if (char === '0') {
            formatted += national[digitIndex]
            digitIndex += 1
        } else {
            formatted += char
        }
    }
    if (digitIndex < national.length) {
        formatted += national.slice(digitIndex)
    }
    return formatted
}

export function contractDefaultPhoneCountryIso(contract?: { settings?: { default_phone_country?: string } } | null): string {
    return normalizePhoneCountryIso(contract?.settings?.default_phone_country)
}
